import React from 'react';
import { useId } from "react-id-generator";
import { svgProps } from 'commons/components/MetsIcon/svg-properties';

interface SubscriptionPackagePerksListProps {

    /** List of labels for the perk list */
    perks: string[]
}


/**
 * List of perks to be displayed inside a Subscription Package tile selector
 *  
 */
const SubscriptionPackagePerksList = (props:SubscriptionPackagePerksListProps) => {

    const [htmlId] = useId(1, "icon-");
    const iconProps = svgProps["svg_checkmarkCircle4"];

    return (
        <div className="perk-list">
            {props.perks.map((perkLabelText, i) => {
                return (
                    <div key={i} className="perk-list-entry">
                        <svg viewBox={iconProps.viewbox} id={htmlId} focusable={false} className={"mets-icon "} aria-labelledby={`${htmlId}_title`}>
                            <use xlinkHref={`${iconProps.imageUrl}#${iconProps.imageId}`}></use>
                        </svg>
                        <span id={`${htmlId}_title`} className="perk-list-entry-label">{perkLabelText}</span>
                    </div>
                );
            })}
        </div>
    );
 
}

export default SubscriptionPackagePerksList;